      <template>
        <div v-show="cfg.count_pages >= 1">
          <ul :class="['pagination-box',mix_class?mix_class:'']">
            <span class="page-first" style="color: #3772ff" @click="setPage(cfg.page_current=1)">First</span>
            <li
                @click="setPage(cfg.page_current-1<=0?1:cfg.page_current-1)"
                :class="['el-item mr-2',{'op5': cfg.page_current <= 1}]"
            >
              <span class="el-link" title="Previous">
               <img class="page-arrow-icon" src="../../images/page/arrow-left.png"/>
              </span>
            </li>
            <li
                :class="['el-item']"
            >
              <span class="el-link" style="cursor: default;">{{ cfg.page_current }} / {{ cfg.count_pages }}</span>
            </li>

            <li
                @click="setPage(cfg.page_current+1>render_log.end_max?render_log.end_max:cfg.page_current+1)"
                :class="['el-item mr-2',{'op5': cfg.page_current >= cfg.count_pages}]"
            >
              <span class="el-link" title="Next">
                <img class="page-arrow-icon page-arrow-icon-right" src="../../images/page/arrow-right.png"/>
              </span>
            </li>
            <span @click="setPage(cfg.page_current=cfg.count_pages)"  class="page-first" style="color: #3772ff">Last</span>
          </ul>
        </div>
      </template>

      <script>
      // 使用须知：
      // mix_class 是用来混入class的
      // count_items 大于0，或 count_pages 大于0，表示有数据，这时组件才显示

      // config 常用配置示例：
      // {
      //   'page-size': 10, //每页条目数量
      //   'page-current': 1, // 当前页
      //   'count_items': 100, //总个数，和总页数选填其一
      //   'btn_num': 5, // 按钮个数
      //   'turnpage_top': true, // 翻页时操作滚动置顶
      //   'count_pages': 100, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
      // }

      // 触发父组件更新： @reloadList="getXxxList()"

      export default {
        name: 'paginationSp',
        props: [
          'mix_class',
          'config',
        ],
        data() {
          return {
            pages_available: [],

            render_log: null,
          }
        },
        computed: {
          cfg() {
            let temp = Object.assign({
              "page_size": 25,
              "page_current": 1,
              "count_items": 1,
              "count_pages": 1,
              "btn_num": 5,
            }, this.config)

            return temp
          },
        },
        watch: {
          cfg: {
            'deep': true,
            'handler': function () {
              this.render()
            }
          },
        },
        methods: {
          // dom 渲染
          render() {
            let cfg = this.cfg

            // 没有数据时，停止渲染
            if (cfg.count_items === 0 && cfg.count_pages === 0) {
              return
            }
            let start = cfg.page_current - parseInt(cfg.btn_num / 2)
            let end = cfg.page_current + parseInt(cfg.btn_num / 2)
            let end_max = cfg.count_pages || Math.ceil(cfg.count_items / cfg.page_size)

            // 确定起始页码
            if (start < 1) {
              end = end + (1 - start)
              start = 1
            }
            // 确定终止页码
            if (end > end_max) {
              start = start - (end - end_max)

              end = end_max
              if (start < 1) {
                start = 1
              }
            }

            // 记录个日志
            this.render_log = {
              start,
              end,
              end_max,
            }

            // 赋值循环项
            let temp = []
            for (let i = start; i <= end; i++) {
              temp.push(i)
            }
            this.pages_available = temp
          },

          // set
          setPage(page_num) {
            //
            if (page_num === this.config.page_current) {
              return
            }
            this.config.page_current = page_num

            this.$emit('reloadList')

            // 如有配置翻页置顶，则置顶
            // if(this.config.turnpage_top){
            //   $('html,body').animate({ scrollTop: 0}, 0);
            // }
          },
        },
        created() {
          this.render()
        },
      }
      </script>

      <style lang="scss">

      .pagination-box {
        //font-family: "Inter var", sans-serif;
        margin-bottom: 0;
        margin-left: 0;
        padding-left: 0;;
        list-style: none;
        display: flex;
        justify-content: center;

        .el-item {

          &.on {
            .el-link {
              background-color: #ddd;
            }
          }

          .el-link {
            border-radius: 10px;
            display: inline-block;
            min-width: 20px;
            text-align: center;
            cursor: pointer;
            user-select: none;
            color: #1a1a1a;
            transition: all .2s;
            background-color: transparent;
            margin: 0 3px;

            &:hover {
              color: #1a1a1a;
            }
          }
        }

        .page-arrow-icon {
          width: 9px;
          margin-left: 15px;
        }

        .page-arrow-icon-right {
          margin-left: 0.5rem;
          margin-right: 15px;
        }

        .page-first {
          cursor: pointer;
        }
      }
      </style>
